module.exports = __webpack_public_path__ + "img/solar.f59fc1e.jpg";